import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { GET_CAMPAIGN_SUBSCRIPTIONS } from '@/graphql/subscription-queries'

const ACTIVE_STATUSES = new Set(['active', 'trialing'])

export const useCampaignSubscription = (campaignId, { fetchPolicy = 'cache-and-network' } = {}) => {
    const { data, loading, error, refetch } = useQuery(GET_CAMPAIGN_SUBSCRIPTIONS, {
        variables: { campaignId },
        skip: !campaignId,
        fetchPolicy,
        errorPolicy: 'all',
    })

    return useMemo(() => {
        const subscriptions = data?.getCampaignSubscriptions ?? []
        const byType = (type) => subscriptions.filter((s) => s.type === type)
        const hasActive = (type) => byType(type).some((s) => ACTIVE_STATUSES.has(s.status))

        return {
            loading,
            error,
            subscriptions,
            hasAnySubscription: subscriptions.length > 0,
            hasActiveLicense: hasActive('LICENSE'),
            hasActiveSupport: hasActive('SUPPORT'),
            hasActiveCreatives: hasActive('CREATIVES'),
            refetch,
        }
    }, [data, loading, error, refetch])
}
